import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import FeedbackPrompt from '@/components/FeedbackPrompt';

export default function PublicFeedbackPage() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const orderId = params.get('order') || undefined;
  const source = params.get('source') || 'web';
  const [open, setOpen] = useState(true);
  const [done, setDone] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center justify-between border-b border-border bg-card px-4 py-3 sm:px-6">
        <div className="flex items-center gap-2">
          <Button size="sm" variant="ghost" onClick={() => nav('/')}><ArrowLeft className="mr-1 h-4 w-4" /> Home</Button>
        </div>
        <h1 className="font-display text-lg font-semibold">Leave feedback</h1>
        <div />
      </header>
      <main className="mx-auto max-w-md space-y-4 px-4 py-10 sm:px-6">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 font-display">
              <MessageCircle className="h-5 w-5 text-primary" /> Tell us how it went
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {!done ? (
              <>
                <p className="text-sm text-muted-foreground">
                  Rate your visit and (optionally) share what we can improve. Anonymous unless you choose to add your name.
                </p>
                <Button data-testid="public-feedback-open-button" onClick={() => setOpen(true)} className="w-full">
                  Start rating
                </Button>
              </>
            ) : (
              <div className="py-6 text-center" data-testid="public-feedback-thanks">
                <p className="font-display text-2xl">Thank you!</p>
                <p className="mt-2 text-sm text-muted-foreground">Your feedback was recorded. We appreciate you.</p>
                <Button className="mt-4" onClick={() => nav('/')}>Back to home</Button>
              </div>
            )}
          </CardContent>
        </Card>
      </main>
      <FeedbackPrompt
        open={open}
        onOpenChange={setOpen}
        source={source}
        orderId={orderId}
        authed={false}
        onSubmitted={() => setDone(true)}
        title="Share your experience"
        description="Tap a star to rate. Optionally add a quick comment."
      />
    </div>
  );
}
